import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import { MdAddLink } from "react-icons/md";
import { Link } from "react-router-dom";
import UpdateOffer from "./UpdateOffer"; // Component for editing
import ReactQuill from "react-quill"; // Step 2: Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Step 2: Import Quill styles

const apiUrl = config.apiUrl;

const ViewOffer = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingOffer, setEditingOffer] = useState(null);
  const [formData, setFormData] = useState({
    slug: "",
    offerHeadline: "",
    offerPrice: "",
    offerSubHeadline: "",
    paymentText: "",
    paymentNumber: "",
    redirect:"",
    buttonText: "",
    pixelId: "",
  });

  // Fetch offers from API
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/offers`);
        setOffers(response.data.offers);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching offers:", err);
        setError("Failed to load offers.");
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this offer?")) {
      try {
        await axios.delete(`${apiUrl}/offerdelete/${id}`);
        setOffers((prev) => prev.filter((offer) => offer.id !== id));
      } catch (err) {
        console.error("Error deleting offer:", err);
        setError("Failed to delete offer.");
      }
    }
  };

  // Handle Edit Button Click
  const handleEditClick = (offer) => {
    setEditingOffer(offer.id);
    setFormData({
      slug: offer.slug,
      offerHeadline: offer.offerHeadline,
      offerPrice: offer.offerPrice,
      offerSubHeadline: offer.offerSubHeadline,
      paymentText: offer.paymentText,
      paymentNumber: offer.paymentNumber,
      redirect: offer.redirect,
      buttonText: offer.buttonText,
      pixelId: offer.pixelId,
    });
  };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, paymentText: value }));
  };


  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingOffer) {
      setError("No offer selected for editing.");
      return;
    }

    try {
      await axios.put(`${apiUrl}/offersupdate/${editingOffer}`, formData);
      alert("Offer updated successfully");
      setOffers((prev) =>
        prev.map((offer) =>
          offer.id === editingOffer ? { ...offer, ...formData } : offer
        )
      );
      setEditingOffer(null); // Clear editing state
    } catch (err) {
      console.error("Error updating offer:", err);
      setError("Failed to update offer.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Offer List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Slug</th>
            <th className="border border-gray-300 px-4 py-2">Headline</th>
            <th className="border border-gray-300 px-4 py-2">Price</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {offers.map((offer) => (
            <tr key={offer.id}>
              <td className="border border-gray-300 px-4 py-2">{offer.slug}</td>
              <td className="border border-gray-300 px-4 py-2">{offer.offerHeadline}</td>
              <td className="border border-gray-300 px-4 py-2">{offer.offerPrice}</td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(offer)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(offer.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
                <Link
                  to={`/offer/${offer.slug}`}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingOffer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateOffer
              formData={formData}
              handleChange={handleChange}
              handleQuillChange={handleQuillChange}
              handleSubmit={handleSubmit}
              loading={loading}
              error={error}
              onCancel={() => setEditingOffer(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewOffer;
